import React from "react";
import { thStyle, tHeadStyle } from '../styles';

export const TableHeader = ({ status }) => (
  <tr style={tHeadStyle}>
    <th style={thStyle}>Name</th>
    <th style={thStyle}>Property</th>
    {status !== 'recurring' ? <th style={thStyle}>Cost</th> : null}
    <th style={thStyle}>Created By</th>
    {status === 'open' ? <th style={thStyle}>Date Created</th> : status === 'completed' ? <th style={thStyle}>Date Completed</th> : <th>Date Canceled</th>}
    <th style={thStyle}>Assigned</th>
    {status === 'open' ? <th style={thStyle}>Due Date</th> : null }
    {status !== 'recurring' ? <th style={thStyle}>Progress</th> : <th style={thStyle}>Recurs</th>}
  </tr>
)